import { createSelector, createFeatureSelector } from "@ngrx/store";
import { State as SoftLabelState } from "../../soft-labels/reducers/soft-labels";

export const selectSoftLabelState = createFeatureSelector<SoftLabelState>('softLabels');

export const getClientsLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.ClientsLabel;
    }
    return '';
  }
);

export const getEstatesLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.EstatesLabel;
    }
    return '';
  }
);

export const getHeadLeasesLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.HeadLeasesLabel;
    }
    return '';
  }
);

export const getLeasesLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.LeasesLabel;
    }
    return '';
  }
);

export const getLandlordsLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.LandlordsLabel;
    }
    return '';
  }
);

export const getPropertiesLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.PropertiesLabel;
    }
    return '';
  }
);

export const getUnitsLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.UnitsLabel;
    }
    return '';
  }
);

export const getVacantsLabel = createSelector(
  [selectSoftLabelState],
  (softLabelState: SoftLabelState) => {
    if (softLabelState && softLabelState.entitySoftlabels) {
      return softLabelState.entitySoftlabels.VacantsLabel;
    }
    return '';
  }
);
